import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PatientService } from '@app/_services/patient.service';
import { AlertService } from '@app/_services';
import {
  ShowOnDirtyErrorStateMatcher,
  ErrorStateMatcher,
} from '@angular/material/core';
import { Options } from '@angular-slider/ngx-slider';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  templateUrl: 'calculator.component.html',
  styleUrls: ['calculator.component.scss'],
})
export class CalculatorComponent {


  constructor(
    private patientService: PatientService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {

  }




}
